import { isEqual } from "lodash";
import { EstructuraEspecifica, FiltroTableMasterGeneral, ValoresEspecificos } from "../models/tabla-maestra.model";

interface sessionMaster{
    structure:EstructuraEspecifica,
    filter:FiltroTableMasterGeneral[],
    data?:ValoresEspecificos[],
}

export class SessionStorageManagement{

public setMasterTaskPersistentData(id_task:number,master_structure:EstructuraEspecifica,master_filter:FiltroTableMasterGeneral[],master_data:ValoresEspecificos[]) {
    let actualData = [];
    const newData: sessionMaster= {
        structure: master_structure,
        filter:master_filter,
        data:master_data
    };
    let sessionMasterResult = sessionStorage.getItem(id_task.toString());
    if(sessionMasterResult){
        actualData = JSON.parse(sessionMasterResult);   
    }
    actualData.push(newData);
    sessionStorage.setItem(id_task.toString(), JSON.stringify(actualData));
};

public getMasterTaskPersistentData(id_task:number,master_structure:EstructuraEspecifica,master_filter:FiltroTableMasterGeneral[]) {
    let result:ValoresEspecificos[] = []
    const  sessionMasterResult = sessionStorage.getItem(id_task.toString());
    if(sessionMasterResult){
        let actualData = JSON.parse(sessionMasterResult); 
        for (const _data of actualData) {
            if (
              _data.structure.maestra ===
              master_structure.maestra &&
              isEqual(_data.structure.columnas, master_structure.columnas) &&
              isEqual(_data.filter, master_filter)
            ) {
              result = _data.data;
              break;
            }
          }
    }
    return result;
};

public updateMasterTaskPersistentData(id_task:number,master_structure:EstructuraEspecifica,master_filter:FiltroTableMasterGeneral[],master_data:ValoresEspecificos[]) {
    
};

public deleteMasterTaskPersistentData(id_task:number) {
    sessionStorage.removeItem(id_task.toString());
};

public deletePersistentData() {
    sessionStorage.clear();
};

public validSessionStorage(){
    if (typeof(Storage) !== 'undefined') {
        return true;
    } else {
       return false;
    }
}

}


// WEBPACK FOOTER //
// ./src/app/shared/Library/session-storage-management.ts